import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import "./BpiDetailsView.css"
import BpiDetailsTableRow from './components/BpiDetailsTableRow';
import BpiDetailsTableSupplierDataRow from './components/BpiDetailsTableSuplierDataRow';
import { ConnectedProps, connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as BpiReducer from '../../store/BpiReducer';
import * as MessageReducer from '../../store/MessageReducer';
import { getCategoryDetails } from '../../services/BpiService';

// ------------------------------------------------------------------------------------------------
// component

const connector = connect(
    (state: ApplicationState) => ({ bpiState: state.bpiState, messageState: state.messageState }),
    { ...BpiReducer.actionCreators, ...MessageReducer.actionCreators }
);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface RouteParams {
    code: string;
}

interface Props extends RouteComponentProps<RouteParams>, PropsFromRedux { }

interface State { }

class BpiDetailsView extends React.Component<Props, State> {
    
    // --------------------------------------------------------------------------------------------
    // states

    private working: boolean = false;

    // --------------------------------------------------------------------------------------------
    // lifecycle

    componentDidMount() {
        this.loadCategoryDetailsData();
    }

    // --------------------------------------------------------------------------------------------
    // data

    loadCategoryDetailsData = () => {
        if (this.working) {
            return;
        }

        // load
        this.working = true;

        getCategoryDetails(this.props.match.params.code)
            .then(response => {
                this.working = false;
                if (!response.success) {
                    alert(response.errorMessage);
                }
                else {
                    this.props.setCategoryDetails(response.data);
                    if (response.data) {
                        document.title = `${response.data.categoryName} | Building Product Information`;
                    } else {
                        this.props.history.push('/bpi');
                    }
                }
            })
            .catch(error => {
                this.working = false;
                alert(error);
            });
    }

    renderPublishedDate = () => {
        const now = new Date();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[now.getMonth()];
        const year = now.getFullYear();
        const formattedDate = `${month} ${year}`;

        return <div> Published {formattedDate}</div>;
    };

    // --------------------------------------------------------------------------------------------
    // render

    public render() {

        const { categoryDetails } = this.props.bpiState;

        return (
            <div className='bpi-product-details'>

                {categoryDetails &&
                    <>
                        <div className='title'>
                            <div>
                                {categoryDetails && categoryDetails.categoryName}
                            </div>
                            <div>
                                {this.renderPublishedDate()}
                            </div>
                        </div>

                        <table>
                            <tbody>
                                <BpiDetailsTableRow label='Brand name' values={categoryDetails.brandNames} />
                                <BpiDetailsTableRow label='Product line' values={categoryDetails.productLines} />
                                <BpiDetailsTableRow label='Product description and its intended use' values={categoryDetails.productDescriptionIntendedUses} />
                                <BpiDetailsTableRow label='Product literature' values={categoryDetails.productLiteratures} />
                                <BpiDetailsTableRow label='Manufacturer/importer disclosure' values={categoryDetails.manufacturerImporterDisclosureLinks} />
                                <BpiDetailsTableRow label='Place of manufacture' values={categoryDetails.placeOfManufactures} />
                                <BpiDetailsTableSupplierDataRow label='Manufacturer details' values={categoryDetails.manufacturerDetails} />
                                <BpiDetailsTableSupplierDataRow label='Importer details' values={categoryDetails.importerDetails} />
                                <BpiDetailsTableRow label='Relevant building code clauses' values={categoryDetails.relevantBuildingCodeClauses} />
                                <BpiDetailsTableRow label='Statement on how the building product is expected to contribute to compliance ' values={categoryDetails.contributionToCompliances} />
                                <BpiDetailsTableRow label='Limitations on the use of the building product' values={categoryDetails.usageLimitations} />
                                <BpiDetailsTableRow label='Design requirements that would support the appropriate use of the building product' values={categoryDetails.designRequirements} />
                                <BpiDetailsTableRow label='Installation requirements' values={categoryDetails.installationRequirements} />
                                <BpiDetailsTableRow label='Product installation guide' values={categoryDetails.productInstallationGuides} />
                                <BpiDetailsTableRow label='Maintenance requirements' values={categoryDetails.maintenanceRequirements} />
                                <BpiDetailsTableRow label='Product maintenance guide' values={categoryDetails.productMaintenanceGuides} />
                                <BpiDetailsTableRow label='Description of the warning or ban under section 26' values={categoryDetails.subjectToWarningOrBans} />
                            </tbody>
                        </table>

                    </>}

            </div>
        )
    };
};

export default connector(BpiDetailsView);


